// Lucide glyphs for the composer's compact toolbar only — everywhere else these buttons keep
// their Material Symbols. Only covers icons EditorToolbar renders itself; the macros and
// AI-assistant triggers live outside that map and pass their lucide icon to ToolbarIcon.
export const COMPOSER_TOOLBAR_ICON_OVERRIDES: Record<string, string> = {
  attach_file: 'paperclip',
  link: 'link',
  link_off: 'unlink',
};

// Mockup keeps link always visible next to attach/macros/sidekick, not behind the "Aa" toggle
export const COMPOSER_PINNED_FORMATTING_METHODS = ['link', 'unsetLink'];
